// extracted by mini-css-extract-plugin
export var border = "_1z-8";
export var brand = "_1z-t";
export var button = "_1z-l";
export var center = "_1z-a";
export var centered = "_1z-6";
export var closeButton = "_1z-c";
export var disabledWrapper = "_1z-m";
export var error = "_1z-p";
export var extraLarge = "_1z-4";
export var extraSmall = "_1z-1";
export var fill = "_1z-i";
export var footer = "_1z-h";
export var footerAction = "_1z-j";
export var footerButtons = "_1z-k";
export var header = "_1z-7";
export var headerWithClose = "_1z-d";
export var icon = "_1z-o";
export var info = "_1z-s";
export var inline = "_1z-9";
export var large = "_1z-3";
export var main = "_1z-e";
export var modal = "_1z-0";
export var nearFull = "_1z-5";
export var neutral = "_1z-u";
export var noPadding = "_1z-g";
export var none = "_1z-v";
export var scrollable = "_1z-f";
export var small = "_1z-2";
export var success = "_1z-r";
export var tight = "_1z-n";
export var titleIcon = "_1z-b";
export var warn = "_1z-q";